import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

import EyeIcon from '@/assets/icons/eye';
import EyeOffIcon from '@/assets/icons/eye-off';
import { Text } from '@/components/TextComponent';
import { ds } from '@/components/lib/design.system';
import { common } from '@/styles/styles';

const styles = StyleSheet.create({
    buttonMore: {
        borderBottomWidth: 1,
        borderBottomColor: ds.colorValue.border.strong,
        paddingVertical: 16,
    },
});

export type PersonalInfoItem = {
    value: string;
    label: string;
    onPress: () => void;
    isMasked?: boolean;
};

type PersonalInfoButtonProps = React.ComponentProps<typeof TouchableOpacity> & PersonalInfoItem;

// Masks SSN digits, leaving last 4 visible
const maskSsn = (value: string) => `••••• ${value.slice(-4)}`;

// Masks SSN digits, '####-##-####'
const formatedSSN = (value: string) => value.replace(/^(\d{3})(\d{2})(\d{4})$/, '$1-$2-$3');

const EditComponent = () => {
    const { t } = useTranslation(['common']);
    return (
        <Text fontWeight="bold" textDecorationLine={'underline'}>
            {t('edit')}
        </Text>
    );
};

export const PersonalInfoButton = ({ label, value, onPress, isMasked }: PersonalInfoButtonProps) => {
    const [isSsnVisible, setIsSsnVisible] = useState(false);

    const handleVisibilityIconPress = () => setIsSsnVisible(prevState => !prevState);

    const EyeIconComponent = isSsnVisible ? EyeOffIcon : EyeIcon;
    const IconComponent = isMasked ? EyeIconComponent : EditComponent;
    const iconPressHandler = isMasked ? handleVisibilityIconPress : onPress;

    const displayValue = isMasked && !isSsnVisible ? maskSsn(value) : formatedSSN(value);

    return (
        <TouchableOpacity
            activeOpacity={0.8}
            style={[styles.buttonMore, common.spaceBetweenRow]}
            onPress={onPress}
            disabled={isMasked}
        >
            <View>
                <Text variant="labelLarge" color={ds.colorToken.text.secondary}>
                    {label}
                </Text>
                <Text variant="bodyMedium" color={ds.colorToken.text.primary}>
                    {displayValue}
                </Text>
            </View>
            <TouchableOpacity style={[common.row, common.alignCenter]} onPress={iconPressHandler}>
                <IconComponent marginLeft={12} />
            </TouchableOpacity>
        </TouchableOpacity>
    );
};
